import React from 'react';
import classNames from './Card.module.scss';
import { useAdminTranslation } from '@/admin/hooks/useAdminTranslation';

interface CardProps {
  width: string;
  height: string;
  title: string;
  titleIcon?: string;
  description: string;
  items: {
    label: string;
    value?: string;
  }[];
  comment?: string;
}

const Card = ({ width, height, title, titleIcon, description, items, comment }: CardProps) => {
  const { t } = useAdminTranslation();
  const allLevelsAvgTimeLabel =
    t('studentDataModal.report.allLevelsAvgTime') || "All level's avg. time";

  return (
    <div className={classNames.card} style={{ width: width, height: height }}>
      <div className={classNames.header}>
        <div className={classNames.title}>
          {!!titleIcon && (
            <img className={classNames.icon} src={titleIcon} alt='' aria-hidden='true' />
          )}
          <span className={classNames.text}>{title}</span>
        </div>
        <div className={classNames.description}>
          <span className={classNames.text}>{description}</span>
        </div>
      </div>
      <div className={classNames.list}>
        {items.map((item, index) => {
          const isAllLevelsAvgTime = item.label === allLevelsAvgTimeLabel;
          return (
            <React.Fragment key={`item--${index}`}>
              <div
                className={`${classNames.item} ${isAllLevelsAvgTime ? classNames.allLevelsAvgTimeItem : ''}`}
              >
                <div className={classNames.label}>
                  <span className={classNames.text}>{item.label}</span>
                </div>
                {!!item.value && (
                  <div className={classNames.value}>
                    <span className={classNames.text}>{item.value}</span>
                  </div>
                )}
              </div>
              {index < items.length - 1 && <div className={classNames.seperator}></div>}
            </React.Fragment>
          );
        })}
        {comment && (
          <>
            <div className={classNames.seperator}></div>
            <div className={classNames.item}>
              <div className={classNames.label}>
                <span className={classNames.text}>{comment}</span>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Card;
